/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_OutdatedInputs */

const en_us2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The permission text has changed. Read it again and confirm to carry on.`)
};

const pt_br2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto da autorização mudou. Leia de novo e confirme para continuar.`)
};

const es_419_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El texto de la autorización cambió. Léelo de nuevo y confirma para continuar.`)
};

const pt_pt2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto da autorização mudou. Lê-o outra vez e confirma para continuar.`)
};

const fr_fr2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le texte de l'autorisation a changé. Relis-le et confirme pour continuer.`)
};

const de_de2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Text der Einwilligung hat sich geändert. Lies ihn noch einmal und bestätige, um fortzufahren.`)
};

const it_it2_body_assessment_consent_outdated = /** @type {(inputs: Body_Assessment_Consent_OutdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il testo dell'autorizzazione è cambiato. Rileggilo e conferma per continuare.`)
};

/**
* | output |
* | --- |
* | "The permission text has changed. Read it again and confirm to carry on." |
*
* @param {Body_Assessment_Consent_OutdatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_outdated = /** @type {((inputs?: Body_Assessment_Consent_OutdatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_OutdatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_outdated(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_outdated(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_outdated(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_outdated(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_outdated(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_outdated(inputs)
	return en_us2_body_assessment_consent_outdated(inputs)
});
export { body_assessment_consent_outdated as "body_assessment.consent_outdated" }